import PropTypes from "prop-types";
import classNames from "classnames/bind";
import styles from "./WareHouse.module.css";
import RenderStatus from "../../../../components/StatusRender";

const cx = classNames.bind(styles);

const Camera = ({ name, status, camID, index, cameraCode, onChangeCamera }) => {
  const companyCode = sessionStorage.getItem('company_code');
  const handleChoseCamera = (code) => {
    onChangeCamera(code, name)
  };
  return (
    <div
      className={cx("item-cam", camID === cameraCode ? "active" : "")}
      onClick={(e) => handleChoseCamera(camID)}
    >
      <div className={cx("camera")}>
        <span className={cx("hover")}>
          <RenderStatus status={status} companyCode={companyCode} />
          <p className={cx('tooltip', index === 0 ? 'bottom' : 'top')}>
            {status === 0 ? 'Đang trực tuyến' :
              status === 3 ? 'Sẵn sàng' :
                'Mất kết nối'
            }
          </p>
        </span>
        <span className={cx("name")}>{name}</span>
      </div>
      {/* <input
        checked={camID === cameraCode}
        className={cx("check")}
        type="checkbox"
      /> */}
    </div>
  );
};
Camera.propTypes = {
  name: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  check: PropTypes.bool.isRequired,
  camID: PropTypes.string.isRequired,
};
export default Camera;
